import { ComponentProps } from "react"
import { cx } from "~/lib/utils"

export const Eyebrow = ({ className, ...props }: ComponentProps<"p">) => (
  <p
    className={cx(
      "text-[0.6875rem] font-medium uppercase tracking-wider text-muted-foreground/60",
      className,
    )}
    {...props}
  />
)
